import { eventChannel } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';
import type { CashbackFromBackend } from 'app/api/services/client/client-info/types';

import mainHubInstance from '../../../hub/main-hub';
import { TRIGGERS_BY_TOPIC } from '../../constants';
import { calculateDelta } from './calculate-delta-util';
import { getTriggerByApplyState } from './get-trigger-by-apply-state';

// ---

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type iDontKnow = any; // TODO: описать тип, когда дойдут руки

// ---

type TriggersKeys = keyof typeof TRIGGERS_BY_TOPIC;
type Handlers = Record<TriggersKeys, (payload: iDontKnow) => void>;

function subscribeToHubEvents() {
  return eventChannel((emit) => {
    const handlers: Handlers = {
      'update-balance': (payload: iDontKnow) => emit(TRIGGERS_BY_TOPIC['update-balance'](payload)),
      'set-unread-notifications-count': (unreadNotificationsCount: number) => emit(TRIGGERS_BY_TOPIC['set-unread-notifications-count'](unreadNotificationsCount)),
      'update-cashback-experience': (payload: CashbackFromBackend) => emit(TRIGGERS_BY_TOPIC['update-cashback-experience'](payload)),
      'apply-state': (payload: iDontKnow) => {
        const trigger = getTriggerByApplyState(payload.topic, TRIGGERS_BY_TOPIC['apply-state']);

        if (trigger) {
          emit(trigger({
            ...payload,
            delta: calculateDelta(payload.serverTime),
          }));
        }
      },
    };

    const handlersKeys = Object.keys(handlers) as (keyof typeof handlers)[];

    handlersKeys.forEach((event) => {
      mainHubInstance.emmiter.on(event, handlers[event]);
    });

    // emit(END) не вызывается, потому что эти соединения должны прослушиваться постоянно
    return () => {};
  });
}

export function* hubEventsSaga(): SagaIterator {
  const channel = yield call(subscribeToHubEvents);

  yield takeEvery(channel, function* (action) {
    yield put(action);
  });
}
